import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Button, Typography } from 'antd';
import './merchantCommitment.css';

const { Title, Paragraph, Text } = Typography;

/**
 * 商家入驻承诺书模板（可打印填写后签字/盖章扫描上传）。
 */
const MerchantCommitmentTemplate: React.FC = () => {
  const [params] = useSearchParams();
  const merchantName = params.get('name') || '____________________';

  return (
    <div className="mc-page">
      <div className="mc-toolbar no-print">
        <Link to="/">返回首页</Link>
        <Button type="primary" onClick={() => window.print()}>
          打印 / 另存为 PDF
        </Button>
      </div>

      <article className="mc-sheet">
        <Title level={2} className="mc-title">
          LabMind 平台商家入驻承诺书
        </Title>
        <Paragraph className="mc-sub">
          （请用黑色签字笔填写空白处，负责人手写签字或加盖公章后扫描/拍照上传）
        </Paragraph>

        <section className="mc-block">
          <Title level={5}>一、商铺与负责人信息</Title>
          <p>商铺名称：{merchantName}</p>
          <p>商铺地址：______________________________________________</p>
          <p>统一社会信用代码：______________________________________</p>
          <p>负责人姓名（与身份证一致）：______________________________</p>
          <p>身份证号码：____________________________________________</p>
          <p>联系电话：____________________ 电子邮箱：________________</p>
        </section>

        <section className="mc-block">
          <Title level={5}>二、承诺条款</Title>
          <Paragraph>
            本商铺（以下简称「本商家」）自愿申请入驻 LabMind
            实验室管理系统商家服务通道，并就以下事项向平台及实验室用户作出郑重承诺：
          </Paragraph>
          <ol className="mc-ol">
            <li>
              <strong>资质齐全真实：</strong>
              本商家保证已依法取得开展经营活动所需的营业执照及相关行政许可；所提交的营业执照、身份信息及其他资质材料真实、有效、完整，不存在伪造、变造或冒用情形。资质变更、吊销或过期时，将及时书面告知平台并更新材料。
            </li>
            <li>
              <strong>商品与服务质量：</strong>
              本商家保证所售耗材、试剂等商品来源合法、质量合格、标识规范；若因商品质量、效期、规格不符等问题导致实验室用户受损或无法正常使用，本商家承诺提供<strong>免费退换货</strong>服务，并承担由此产生的合理运费及协商一致的补救责任。
            </li>
            <li>
              <strong>价格真实透明：</strong>
              本商家承诺报价、实付价格及促销信息真实、清晰，不以虚假原价、隐瞒费用等方式误导用户；价格调整将按平台规则通知并经必要确认后生效。
            </li>
            <li>
              <strong>履约与发货：</strong>
              本商家将在合理期限内接单、发货，并如实填写快递单号；因本商家原因无法履约时，将及时拒单或协商处理，不得无故拖延。
            </li>
            <li>
              <strong>用户隐私与数据保护：</strong>
              本商家仅可为履约（如发货、售后）目的使用用户提供的收件人姓名、电话、地址等信息，不得出售、泄露或用于与订单无关的营销；发生或可能发生信息泄露时，将立即采取补救措施并通知平台。
            </li>
            <li>
              <strong>合规经营：</strong>
              本商家遵守国家法律法规及平台规则，不销售违禁、管制或未经批准的物品，不实施欺诈、串通虚假交易等行为。
            </li>
            <li>
              <strong>配合审核与责任：</strong>
              本商家同意平台对入驻及资料变更进行审核；因违反本承诺书或提供虚假材料造成平台或第三方损失的，本商家愿意依法承担相应责任，并接受平台采取限制接单、下架、停用直至清退等措施。
            </li>
          </ol>
        </section>

        <section className="mc-block">
          <Title level={5}>三、声明</Title>
          <Paragraph>
            本人已仔细阅读并理解上述全部条款。本承诺书自签字（或盖章）之日起生效，扫描件与原件具有同等效力。
          </Paragraph>
        </section>

        <section className="mc-sign">
          <p>商铺名称（盖章）：________________________</p>
          <p>负责人签字：____________________</p>
          <p>身份证号：______________________</p>
          <p>签署日期：______年____月____日</p>
        </section>

        <Paragraph type="secondary" className="mc-foot">
          模板仅供 LabMind 商家入驻使用。填写完成后请扫描或拍照上传清晰完整的承诺书影像。
        </Paragraph>
      </article>
    </div>
  );
};

export default MerchantCommitmentTemplate;
